module.exports = __webpack_public_path__ + "img/jzgz.adcd2fb1.png";